import template from './loansDetailStatementIncome.html';
import controller from './loansDetailStatementIncome.controller';
import './loansDetailStatementIncome.scss';

let loansDetailStatementIncomeComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansDetailStatementIncomeComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailStatementIncome/loansDetailStatementIncome.component.js